import { SortDirection } from '@stylehaven/components';
import { UserId } from '../../record/entities/metadata.entity';

export interface SavedQuerySearch {
    startIndex?: number;
    nrOfResults: number;
    name?: string;
    createdBy?: UserId;
    organisationId?: string;
    fieldKeyType?: FieldKeyType;
    sort?: string;
    direction?: SortDirection;
}

export enum FieldKeyType {
    DottedKey = 'DottedKey',
    FlatKey = 'FlatKey'
}
